module.exports = __webpack_public_path__ + "fonts/Poppins-Italic.89c81a3c.ttf";